import {
  Box,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { Flex } from "~/components/Flex";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import {
  AffectedEcosystemsType,
  AffectedEcosystemVersionsType,
} from "~/components/Remediation/types";
import { RemediationDropdownsSkeleton } from "~/components/Remediation/RemediationFilter/RemediationDropdownsSkeleton";

export type Props = {
  isLoading: boolean;
  selectedEcosystemTitle: string;
  selectedEcosystemVersion: string;
  ecosystems: AffectedEcosystemsType;
  onEcosystemTitleChange: (event: SelectChangeEvent) => void;
  onEcosystemVersionChange: (event: SelectChangeEvent) => void;
  selectedEcosystemsVersions: AffectedEcosystemVersionsType;
};

export const Ecosystems = ({
  isLoading,
  ecosystems,
  selectedEcosystemTitle,
  selectedEcosystemVersion,
  onEcosystemTitleChange,
  onEcosystemVersionChange,
  selectedEcosystemsVersions,
}: Props) => {
  return isLoading ? (
    <RemediationDropdownsSkeleton />
  ) : (
    <Box data-testid="ecosystem-selector">
      <Typography textTransform="uppercase" fontWeight={700} mb={2}>
        Select the version to fix
      </Typography>
      <Grid container size={{ xs: 6 }} spacing={3} mb={2}>
        <Grid size={{ xs: 6 }}>
          <Select
            data-testid="ecosystem-title"
            variant="outlined"
            fullWidth
            // disabled={!hasCreateCasePermissions}
            sx={{
              "&.MuiInputBase-root": {
                bgcolor: "code.background",
              },
            }}
            displayEmpty
            value={selectedEcosystemTitle}
            onChange={onEcosystemTitleChange}
          >
            {ecosystems.map(({ friendlyName, icon }, index) => {
              return (
                <MenuItem key={`${friendlyName}-${index}`} value={friendlyName}>
                  <Flex gap={1}>
                    {icon && <DynamicIcon iconId={icon} />}
                    {friendlyName}
                  </Flex>
                </MenuItem>
              );
            })}
          </Select>
        </Grid>
        {selectedEcosystemsVersions.length > 0 && (
          <Grid size={{ xs: 6 }}>
            <Select
              data-testid="ecosystem-version"
              variant="outlined"
              data-test-id="case-select-input"
              fullWidth
              sx={{
                "&.MuiInputBase-root": {
                  bgcolor: "code.background",
                },
              }}
              displayEmpty
              value={selectedEcosystemVersion}
              onChange={onEcosystemVersionChange}
            >
              {selectedEcosystemsVersions.map((e) => (
                <MenuItem value={e.ecosystem} key={e.ecosystem}>
                  {e.ecosystem}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
